import MessageComposer from './MessageComposer';
import * as React from 'react';
import invariant from 'invariant';
import Chat from 'entities/Chat';
import { GetLanguageSet_translations_getLanguageSet_data_languageCounts as LanguageCounts } from '../../translations/queries/__generated__/GetLanguageSet';

type Props = {
  chat: Chat;
  onMessageSend?: Function;
  className?: string;
  languageCounts?: LanguageCounts[];
};

export class ConversationViewComposer extends React.Component<Props> {
  composer: any;

  focus() {
    if (this.composer) {
      // XXX there should be a better way to enforce this
      invariant(
        this.composer.getDecoratedComponentInstance,
        'composer must be decorated by React-dnd'
      );
      this.composer.getDecoratedComponentInstance().focus();
    }
  }

  render() {
    const { className, chat, onMessageSend, languageCounts, ...rest } = this.props;

    return (
      <MessageComposer
        {...rest}
        chat={chat}
        reference={(c: any) => {
          this.composer = c;
        }}
        className={className}
        onMessageSend={onMessageSend}
        languageCounts={languageCounts ?? []}
      />
    );
  }
}

export default ConversationViewComposer;
